import React from 'react';

class RowProcessed extends React.Component {

    deleteInvoiceItem = () => {
        this.props.deleteInvoiceItem(
            this.props.invoiceItem._internalId,
        );

        this.props.notifyError(
            'A tétel törölve lett a kimenetből.',
        );
    };

    deleteInvoice = () => {
        this.props.deleteInvoice(
            this.props.invoice._internalId,
        );

        this.props.notifyError(
            'A számla törölve lett a kimenetből.',
        );
    };

    showRule = () => {
        this.props.onShowRule(
            this.props.invoiceItem.rule_id,
        );
    };

    render() {
        const {
            invoice,
            invoiceItem,
            itemIndex,
        } = this.props;

        const supplierName = (
            invoice
            && invoice.supplier
            && invoice.supplier.name
        )
            ? invoice.supplier.name
            : '-';

        const bookkeepingNumber =
            invoiceItem.main_bookkeeping_number_custom
            || invoiceItem.main_bookkeeping_number
            || '';

        const vatPercentage = Number(
            invoiceItem.vatPercentage,
        ) * 100;

        return (
            <tr className={itemIndex === 0 ? 'border-top-2' : ''}>
                <td>
                    <button
                        type="button"
                        className="table-green-btn"
                        onClick={this.showRule}
                    >
                        #{invoiceItem.rule_id}
                    </button>
                </td>
                <td>{invoice.invoiceNumber || '-'}</td>
                <td>{supplierName}</td>
                <td>{invoice.customer.name || '-'}</td>
                <td>{invoiceItem.name || '-'}</td>
                <td>{invoice.positionNumberCountry || '-'}</td>
                <td>{invoice.orderNumberStat || '-'}</td>
                <td>{bookkeepingNumber}</td>

                <td>{Number.isNaN(vatPercentage) ? '-' : `${vatPercentage}%`}</td>
                <td>{invoiceItem.vat_collector_title || '-'}</td>
                <td>{invoiceItem.vat_degree || '-'}</td>
                <td>
                    <button
                        type="button"
                        className="btn btn-link p-0 mr-2"
                        onClick={this.deleteInvoiceItem}
                        title="Tétel törlése a kimenetből"
                    >
                        <i
                            className="fa fa-trash-o"
                            aria-hidden="true"
                        />
                    </button>

                    <button
                        type="button"
                        className="btn btn-link p-0"
                        onClick={this.deleteInvoice}
                        title="Számla törlése a kimenetből"
                    >
                        <i
                            className="fa fa-trash"
                            aria-hidden="true"
                        />
                    </button>
                </td>
            </tr>
        );
    }
}

export default RowProcessed;


// WEBPACK FOOTER //
// ./src/components/supplier/steps/assignment/RowProcessed.js